import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {
  DeleteFilled,
  EditFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { Button, Input, Table } from 'antd';

import { companyListTableHeader as columns } from '@/utils/tableHeader';
import { goToCompanyEditForm } from './form/common';

//  api
import { handleDeleteCompanyAPI } from './form/crud/index';
import { companyApiEndpoints } from '@/api/endpoints';

import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';
import GlobalModal from '@/utils/modal/Modal';
import '@/assets/style/modern-group-list.css';

const CompanyList = () => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const { data, isLoading, refresh } = useFetch(
    companyApiEndpoints.retrieveList,
  );

  const navigate = useNavigate();
  const [id, setId] = useState(null);

  const filteredData = globalSearch(data || [], searchQuery);

  const goToCompanyCreateForm = () => {
    navigate('/company/create/');
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const openModal = (id) => {
    setId(id);
    setOpen(true);
  };

  const handleOk = () => {
    setOpen(false);
    handleDeleteCompanyAPI(id, refresh);
  };

  return (
    <>
      <GlobalModal
        isVisible={open}
        onConfirm={handleOk}
        onClose={handleCancel}
        type="delete"
        customContent="Are you sure you want to delete this company?"
      />

      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Company</h1>
            <p className="modern-group-subtitle">
              Manage and organize your companies
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              placeholder="Search Company..."
              value={searchQuery}
              prefix={<SearchOutlined />}
              onChange={(event) => setSearchQuery(event.target.value)}
              style={{ width: '300px' }}
            />
            <Button
              className="centered"
              type="primary"
              onClick={goToCompanyCreateForm}
            >
              <PlusOutlined />
              Create
            </Button>
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            size="large"
            bordered
            loading={isLoading}
            rowKey="referenceId"
            columns={columns?.map((col) => {
              if (col.dataIndex === 'action') {
                return {
                  ...col,
                  render: (_, record) => (
                    <div className="ant-action tw-flex tw-gap-4 tw-justify-center tw-align-center">
                      <Link
                        to={goToCompanyEditForm(record.referenceId)}
                        className="edit tw-inline-flex tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full tw-p-1"
                      >
                        <EditFilled className="tw-text-blue-600" />
                      </Link>
                      <span
                        className="text-danger tw-inline-flex tw-cursor-pointer hover:tw-bg-red-200 tw-rounded-full tw-p-1"
                        onClick={() => openModal(record.referenceId)}
                      >
                        <DeleteFilled />
                      </span>
                    </div>
                  ),
                };
              }
              if (col.dataIndex === 'index') {
                return {
                  ...col,
                  render: (_, __, i) => i + 1,
                };
              }
              return {
                ...col,
                onCell: () => ({
                  style: { padding: '6px 12px' },
                }),
              };
            })}
            className="ant-border-space"
            style={{ textAlign: 'center' }}
            scroll={{ x: true, y: 'calc(100vh - 220px)' }}
            dataSource={filteredData}
            pagination={false}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyList;
